/**
 * created by lei lei on 2020/6/22
 * 微信其他配置
 *
 *  <WeChatConfigurations ref={(WeChatConfigurations) => {
                    this.WeChatConfigurations = WeChatConfigurations;
                }}/>
 this.WeChatConfigurations.show();//开启
 this.WeChatConfigurations.hide();//关闭
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Button, Input, Row, Col, Radio, message} from 'antd';
import wechat from './img/wechat.png'

export default class WeChatConfigurations extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            appid: '',
            appSecret: '',
            value: 1
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Modal
                    title="微信其他配置"
                    visible={this.state.visible}
                    onOk={() => {
                        this.onClickOk();
                    }}
                    onCancel={() => {
                        this.onClickCancel();
                    }}
                    width={565}
                    bodyStyle={{height: 270}}
                >
                    <div>
                        <div style={{textAlign: 'center'}}>
                            <img style={{width: 50, height: 50}} src={wechat} alt=""/>
                        </div>
                        <div style={{textAlign: 'center', paddingTop: 10}}>
                            请完善以下信息才能将稿件发布在此媒体中
                        </div>
                        <div style={{
                            textAlign: 'center',
                            color: 'red',
                            paddingTop: 10
                        }}>注：填写完以下信息后请将资源管理平台服务器IP地址加入到微信开发平台白名单
                        </div>
                        <div style={{paddingTop: 10}}><Input value={this.state.appid} placeholder="请输入appid"
                                                             onChange={(e) => {
                                                                 this.setState({appid: e.target.value})
                                                             }}/></div>
                        <div style={{paddingTop: 10}}><Input value={this.state.appSecret} placeholder="请输入appSecret"
                                                             onChange={(e) => {
                                                                 this.setState({appSecret: e.target.value})
                                                             }}/></div>
                        <div style={{paddingTop: 10, display: 'flex'}}>
                            <div>公众号类型：&nbsp;&nbsp;</div>
                            <Radio.Group onChange={(e) => {
                                this.setState({
                                    value: e.target.value,
                                });
                            }} value={this.state.value}>
                                <Radio value={1}>订阅号</Radio>
                                <Radio value={2}>服务号</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    //父页面传值到子组件
    show(data = {}) {
        // console.log('父页面的值',data);
        this.state.visible = true;
        this.setState({});
    }

    //隐藏弹出框
    hide() {
        this.setState({visible: false});
    }

    //点击保存
    onClickOk() {
        let body = {
            appid: this.state.appid,
            appSecret: this.state.appSecret,
            gzhtype: this.state.value
        };
        console.log(body);
        if (!body.appid.trim().length > 0) {
            message.warning('请输入appid');
            return
        }
        if (!body.appSecret.trim().length > 0) {
            message.warning('请输入appSecret');
            return
        }

        this.props.callBakc && this.props.callBakc(body);
        this.onClickCancel();

    }

    //点击取消
    onClickCancel() {
        this.setState({
            visible: false,
            appid: '',
            appSecret: '',
            value: 1
        });
    }

}